module.exports = __webpack_public_path__ + "assets/img/SpinTel-Pillar-Page-Resource.d5935acb.jpg";